import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import useApiCallHooks from '../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import OverlayLoader from '../../../components/Common/OverlayLoader';

const StudentRegistration = () => {
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    callAPI("post", "add-contact-us", {
      ...formData,
      type: "campus", // if required by backend
    });
  };

  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Registered Successfully!");
      setTimeout(() => navigate("/"), 2000);
    } else if (statusCode === 500 || error?.message === "ServerError") {
      toast.error("Something went wrong. Please try again.");
    }
  }, [response, error, statusCode, navigate]);

  return (
    <div className="py-5 j-bg-gradient">
      <OverlayLoader show={loading} />

      <div className="container text-center mb-5">
        <h2 className="fw-bold">Ready to Transform Your Career?</h2>
        <p className="text-muted fs-5">
          Register now and get personalized guidance to choose the perfect training roadmap for your goals
        </p>
      </div>

      <div className="container">
        <div className="row shadow rounded bg-white p-4">
          {/* Left Column */}
          <div className="col-md-6 border-end mb-4 mb-md-0">
            <h4 className="fw-bold mb-4">Why Students Choose Us</h4>
            <ul className="list-unstyled text-start">
              {[
                'One-on-one mentorship from industry experts',
                'Tailored learning paths based on your background',
                'Certification upon course completion',
                'Access to real-world projects and case studies',
                'Lifetime access to learning materials',
                'Career support and resume building assistance',
              ].map((item, idx) => (
                <li key={idx} className="mb-3 d-flex align-items-start">
                  <FaCheckCircle className="text-success me-2 mt-1" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="j-success-stories bg-light p-3 rounded mt-4 d-flex justify-content-between text-start">
              <div>
                <h6 className="text-muted mb-0">Success Stories</h6>
                <h4 className="fw-bold text-primary mb-0">95%</h4>
                <small className="text-muted">Placement Rate</small>
              </div>
              <div>
                <h6 className="text-muted mb-0">&nbsp;</h6>
                <h4 className="fw-bold j-text-purple mb-0">5000+</h4>
                <small className="text-muted">Students Trained</small>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-6">
            <div className="singUp-wrap shadow">
              <h2 className="title">Reach Out to Us</h2>
              <form className="account__form" onSubmit={handleSubmit} noValidate>
                <div className="row gutter-20">
                  <div className="col-md-6">
                    <div className="form-grp">
                      <label htmlFor="first-name">First Name</label>
                      <input
                        type="text"
                        name="first_name"
                        id="first-name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={(e) =>
                          setFormData({ ...formData, first_name: e.target.value })
                        }
                        required
                      />
                      {error?.message === "ValidationError" &&
                        error?.data?.first_name?.map((msg, i) => (
                          <div key={i} className="val-message text-danger">{msg}</div>
                        ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-grp">
                      <label htmlFor="last-name">Last Name</label>
                      <input
                        type="text"
                        name="last_name"
                        id="last-name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={(e) =>
                          setFormData({ ...formData, last_name: e.target.value })
                        }
                        required
                      />
                      {error?.message === "ValidationError" &&
                        error?.data?.last_name?.map((msg, i) => (
                          <div key={i} className="val-message text-danger">{msg}</div>
                        ))}
                    </div>
                  </div>
                </div>

                <div className="form-grp">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                  />
                  {error?.message === "ValidationError" &&
                    error?.data?.email?.map((msg, i) => (
                      <div key={i} className="val-message text-danger">{msg}</div>
                    ))}
                </div>

                <div className="form-grp">
                  <label htmlFor="mobile">Mobile No</label>
                  <input
                    type="number"
                    name="mobile_no"
                    id="mobile"
                    placeholder="Mobile No"
                    value={formData.mobile_no}
                    onChange={(e) =>
                      setFormData({ ...formData, mobile_no: e.target.value })
                    }
                    required
                  />
                  {error?.message === "ValidationError" &&
                    error?.data?.mobile_no?.map((msg, i) => (
                      <div key={i} className="val-message text-danger">{msg}</div>
                    ))}
                </div>

                <button type="submit" className="btn text-white rounded">
                  Submit Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentRegistration;
